import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(url, width, quality = 80, height) {
  if (!url || !url.startsWith("https://assets.auxodev.dk/")) {
    return url;
  }
  // Check if it already has cdn-cgi/image
  if (url.includes("/cdn-cgi/image/")) {
    return url;
  }
  const parts = url.split("https://assets.auxodev.dk/");
  const path = parts[1];
  let options = `width=${width},quality=${quality},format=auto`;
  if (height) {
    options += `,height=${height},fit=cover`;
  }
  return `https://assets.auxodev.dk/cdn-cgi/image/${options}/${path}`;
}
